import { buildCommonFilters, embedFilter } from '../sharedFilters'

const DATASET_KEY = 'inventories'

const commonFilters = buildCommonFilters(DATASET_KEY, {
  INSTALLATION: { label: 'REMS' },
  MUNICIPALITY: {},
  STATUS: false,
  REGION: false,
  CENTER: false,
  SECTOR: false,
  TENANT: false,
  USER: false,
})

export default {
  key: DATASET_KEY,
  label: 'Inventarios',
  timeColumn: 'inventories.created_at',
  permission: { action: 'read', subject: 'Inventory' },

  tables: {
    inventories: ["id", "model", "installation_date", "depreciation_start_date", "equipment_cost", "accumulated_depreciation", "useful_life_months", "remaining_life_months", "status", "created_at", "updated_at"],
    inventories_brands_catalog: ["id", "name", "created_at", "updated_at"],
    inventories_equipment_types_catalog: ["id", "name", "created_at", "updated_at"],
    inventories_projects_catalog: ["id", "name", "created_at", "updated_at"],
    units: ["id", "description", "active", "created_at", "updated_at"],
    regions: ["id", "name", "created_at", "updated_at"],
    sectors: ["id", "name", "provider", "created_at", "updated_at"],
    centers: ["id", "name", "created_at", "updated_at"],
  },

  views: [
    { value: 'bar', label: 'Barras' },
    { value: 'dona', label: 'Dona' },
    { value: 'ring', label: 'Pastel' },
    { value: 'dataframe', label: 'Lista', adminOnly: true },
    { value: 'timeseries', label: 'Tendencia' },
    { value: 'json', label: 'JSON', adminOnly: true },
  ],

  defaults: {
    field: 'inventories_brands_catalog.name',
    // field2: 'inventories_equipment_types_catalog.name',
  },

  csvConfig: {
    withTables: 'inventories',
    columns: 'inventories.model,inventories.installation_date,inventories.depreciation_start_date,inventories.equipment_cost,inventories.accumulated_depreciation,inventories.useful_life_months,inventories.remaining_life_months,inventories.status,inventories.created_at,inventories.updated_at,inventories_brands_catalog.name,inventories_brands_catalog.created_at,inventories_brands_catalog.updated_at,inventories_equipment_types_catalog.name,inventories_equipment_types_catalog.created_at,inventories_equipment_types_catalog.updated_at,inventories_projects_catalog.name,inventories_projects_catalog.created_at,inventories_projects_catalog.updated_at,units.description,units.active,sectors.name,regions.name,municipalities.name',
    exceptColumns: 'inventories.id_inventory_brand_catalog,inventories.id_inventory_equipment_type_catalog,inventories.id_inventory_project_catalog',
    qualifiedColumns: true,
  },

  viewDefaults: {
    csv: { limit: -1 },
    dataframe: { limit: -1 },
    json: { limit: -1 },
    bar: { stack: 'group' },
    //timeseries: { trendline: true },
  },

  fields: [
    { key: 'units.description', label: 'REMS' },
    { key: 'regions.name', label: 'Estado' },
    { key: 'municipalities.name', label: 'Municipio' },
    { key: 'centers.name', label: 'Centro' },
    { key: 'sectors.name', label: 'Región' },
    { key: 'inventories.status', label: 'Estatus' },
    { key: 'inventories_brands_catalog.name', label: 'Marca' },
    { key: 'inventories.model', label: 'Modelo' },
    { key: 'inventories_projects_catalog.name', label: 'Proyecto' },
    { key: 'inventories_equipment_types_catalog.name', label: 'Tipo de equipo' },
    { key: 'inventories.installation_date', label: 'Fecha de instalación', defaultParams: { freq: '1mo' } },
    { key: 'inventories.depreciation_start_date', label: 'Fecha inicio depreciación', defaultParams: { freq: '1mo' } },
    { key: 'inventories.equipment_cost', label: 'Costo del equipo' },
    { key: 'inventories.accumulated_depreciation', label: 'Depreciación acumulada' },
    { key: 'inventories.useful_life_months', label: 'Vida útil (meses)' },
    { key: 'inventories.remaining_life_months', label: 'Vida restante (meses)' },
    { key: 'inventories.status', label: 'Estatus' },
    { key: 'inventories.created_at', label: 'Fecha de creación', defaultParams: { freq: '1mo' } },
    { key: 'inventories.updated_at', label: 'Fecha de actualización', defaultParams: { freq: '1mo' } },
  ],

  filters: [
    ...commonFilters,
    embedFilter(DATASET_KEY, 'centers.name', 'Centro', 'center_name'),
    embedFilter(DATASET_KEY, 'sectors.name', 'Región', 'sector'),
    embedFilter(DATASET_KEY, 'regions.name', 'Estado', 'region'),
    embedFilter(DATASET_KEY, 'inventories.status', 'Estatus', 'status'),
    embedFilter(DATASET_KEY, 'inventories_projects_catalog.name', 'Proyecto', 'group'),
    embedFilter(DATASET_KEY, 'inventories_equipment_types_catalog.name', 'Tipo de equipo', 'type'),
    embedFilter(DATASET_KEY, 'inventories_brands_catalog.name', 'Marca', 'name'),
    embedFilter(DATASET_KEY, 'inventories.model', 'Modelo', 'model'),
    embedFilter(DATASET_KEY, 'inventories.equipment_cost', 'Costo del equipo', 'equipment_cost'),
    embedFilter(DATASET_KEY, 'inventories.accumulated_depreciation', 'Depreciación acumulada', 'accumulated_depreciation'),
    embedFilter(DATASET_KEY, 'inventories.useful_life_months', 'Vida útil (meses)', 'useful_life_months'),
    embedFilter(DATASET_KEY, 'inventories.remaining_life_months', 'Vida restante (meses)', 'remaining_life_months'),
    {
      key: 'installation_date',
      label: 'Fecha de instalación',
      filterType: 'where-date',
      whereColumn: 'inventories.installation_date',
      optionsConfig: { type: 'date' },
    },
    {
      key: 'depreciation_start_date',
      label: 'Fecha inicio depreciación',
      filterType: 'where-date',
      whereColumn: 'inventories.depreciation_start_date',
      optionsConfig: { type: 'date' },
    },
    {
      key: 'inventories_updated_at',
      label: 'Fecha de actualización',
      filterType: 'where-date',
      whereColumn: 'inventories.updated_at',
      optionsConfig: { type: 'date' },
    },
  ],

  dateGrouping: {
    column: 'inventories.installation_date',
    presets: [
      { value: '1d', label: 'Día' },
      { value: '1W', label: 'Semana' },
      { value: '1M', label: 'Mes' },
      { value: '1Y', label: 'Año' },
    ],
  },
}
